import FileDownload from 'js-file-download';
import jsToCsv from './jsToCsv';

const gradesFields = [
  'customStudentId',
  'firstName',
  'lastName',
  'email',
  'externalId',
  'grade',
];

const fieldDisplayNames = {
  customStudentId: 'studentId',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  externalId: 'externalId',
  grade: 'grade',
};

const downloadGradeCsv = ({ filename, grades, includeStudentId = false }) => {
  const content = jsToCsv(
    gradesFields,
    grades,
    fieldDisplayNames,
    includeStudentId
  );

  FileDownload(
    content,
    filename.endsWith('.csv') ? filename : `${filename}.csv`,
    'text/csv;charset=utf-8;'
  );
};

export default downloadGradeCsv;
